import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Radio/sgds-radio";
import { register } from "../../utils/ce-registry";

register("sgds-radio", Component);

export default createComponent({
  react: React,
  tagName: "sgds-radio",
  elementClass: Component,
  events: {
    onSgdsFocus: "sgds-focus",
    onSgdsBlur: "sgds-blur"
  }
});
